export const wait = (ms = 1000) =>
  new Promise((resolve) => {
    setTimeout(resolve, ms);
  });

export const areArraysEqual = (arr1, arr2) => {
  if (arr1.length !== arr2.length) return false; // If lengths differ, they are not equal
  return new Set(arr1).size === new Set([...arr1, ...arr2]).size;
};
